import React, { MouseEventHandler } from 'react';

export interface VoxelDrawerMenuItemProps {
  href?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  selected?: boolean;
  disabled?: boolean;
  indented?: boolean;
  variant?: 'normal' | 'emphasis';
}

export const VoxelDrawerMenuItem: React.FC<VoxelDrawerMenuItemProps> = ({
  href,
  onClick,
  selected,
  disabled,
  children,
  indented,
  variant = 'normal',
}) => {
  return (
    <a
      href={href}
      onClick={onClick}
      className={`
       ${!disabled && 'cursor-pointer'}
       ${selected && 'bg-gray-100'}
       ${!selected && !disabled && 'hover:bg-gray-100'}
       select-none
       w-full
       ${indented ? 'pl-8' : 'pl-4'}
       pr-4
       py-1.5
       text-[13px]
       font-sans
       ${variant === 'emphasis' ? 'font-semibold' : 'font-regular'}
       ${disabled && 'text-gray-400'}
   `}
    >
      {children}
    </a>
  );
};

export default VoxelDrawerMenuItem;
